import { ErrorMessageType } from './types'

const TARGET_KEY_AUTH = ['expired', 'unauthorized', 'not authorized']
const TARGET_KEY_ACCESS_DENIED = ['no access allowed', 'access denied', 'not found']

/**
 * improve matching check with some rather than using regex
 * since the regex does grouping checks it will split the @TARGET_KEY into an array
 * that caused issue if the @networkErrorMessage or @title has words of "not" the regex will return @true
 * so using some with a splitter array is the best way and faster than @Regex
 */
const isMatchWithKey = (text: string, keywords: string[]) => {
  return keywords.some((k) => text.includes(k))
}

export const handleAccessDeniedMessage = (networkErrorMessage: string = '', title: string = ''): ErrorMessageType => {
  const messageText = [networkErrorMessage, title].join(' ').toLowerCase()
  /**
   * @authMatch variable
   * is condition if the error message or title will matching with this target key @TARGET_KEY_AUTH
   * so it should return dinamic message as api error response
   */
  const authMatch = isMatchWithKey(messageText, TARGET_KEY_AUTH)
  if (authMatch) {
    return {
      message: networkErrorMessage || 'Your session has expired. Please log in again.',
      title: 'Session Expired',
      isRedirect: true,
      isUnautenticated: true,
    }
  }

  /**
   * @accessDeniedMatch variable
   * is condition if the error message or title will matching with this target key @TARGET_KEY_ACCESS_DENIED
   * so it should return static message and static title with redirect url is available
   */
  const accessDeniedMatch = isMatchWithKey(messageText, TARGET_KEY_ACCESS_DENIED)
  if (accessDeniedMatch) {
    return {
      message:
        'You don’t have access to a Reapit Sales system. Please contact your administrator or try logging in with a different account.',
      title: 'Access Denied',
      isRedirect: true,
    }
  }

  /**
   * this should be default message for all error espessially for 500, 404, and so on
   */
  return {
    message: networkErrorMessage || 'Something went wrong. Please try again.',
    title: title || 'Network Error',
    isRedirect: false,
  }
}
